import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { withFragments } from '@sorare/core/src/lib/gql';

import type { getPackAssets_cardSet } from './__generated__/getPackAssets.graphql';

export const getPackAssets = withFragments(
  (
    cardSet: Nullable<getPackAssets_cardSet>
  ): { desktop: string | undefined; mobile: string | undefined } => ({
    desktop: cardSet?.branding?.packDetailsDesktop ?? undefined,
    mobile: cardSet?.branding?.packDetailsMobile ?? undefined,
  }),
  {
    cardSet: gql`
      fragment getPackAssets_cardSet on CardSet {
        slug
        branding {
          id
          packDetailsDesktop: assetUrl(slot: MARKET_PACK_DETAILS_DESKTOP)
          packDetailsMobile: assetUrl(slot: MARKET_PACK_DETAILS_MOBILE)
        }
      }
    ` as TypedDocumentNode<getPackAssets_cardSet>,
  }
);
